import type { StoneSpecification } from '@/features/pdp/domain/models/ProductDetail';
import { formatPdpCarat } from '@/features/pdp/utils/formatPdpCarat';
import { WeightInfoTooltip } from './WeightInfoTooltip';

const WEIGHT_VARIATION_TEXT =
  'The final invoice amount will be adjusted in case of variation in weight.';

interface PdpMobileStoneSpecTileContentProps {
  spec: StoneSpecification;
  isGemstone?: boolean;
  onInfoIconClick?: (label: string) => void;
}

function getStoneSpecDisplayValue(
  spec: StoneSpecification,
  isGemstone: boolean
): {
  value: string;
  unit: string;
  label: string;
  tooltip: string;
} | null {
  if (spec.totalWeight != null) {
    return {
      value: formatPdpCarat(spec.totalWeight),
      unit: 'Ct',
      label: `${spec.stoneType} Weight`,
      tooltip: WEIGHT_VARIATION_TEXT,
    };
  }

  if (!isGemstone && spec.size) {
    return {
      value: spec.size,
      unit: '',
      label: `${spec.stoneType} Size`,
      tooltip: '',
    };
  }

  return null;
}

export function PdpMobileStoneSpecTileContent({
  spec,
  isGemstone = false,
  onInfoIconClick,
}: PdpMobileStoneSpecTileContentProps) {
  const display = getStoneSpecDisplayValue(spec, isGemstone);
  if (!display) return null;

  return (
    <div className="mx-auto flex w-full flex-col items-center text-center">
      <div className="mb-[3px] whitespace-nowrap border-b border-[#ededed] text-[16.8px] leading-[1.5em] tracking-[1px] max-[359px]:text-xs">
        {display.value}
        {display.unit ? (
          <span className="text-[13px] tracking-[0.7px]"> {display.unit}</span>
        ) : null}
      </div>
      <WeightInfoTooltip
        label={display.label}
        text={display.tooltip}
        onInfoClick={onInfoIconClick}
      />
    </div>
  );
}
